export class Constants {
}
Constants.FileHeader = 0x4D546864; // MThd
Constants.TrackHeader = 0x4D54726B; // MTrk
Constants.TimeDivisionPPQ = 'PPQ';
Constants.TimeDivisionFPS = 'FPS';
Constants.TempoMessage = 0x51; // 81
Constants.MetaMessage = 0xFF; // 255
Constants.ControlMessage = 0xB; // 11
Constants.StringMetaTypes = [
    0x01,
    0x02,
    0x03,
    0x04,
    0x05,
    0x07,
    0x06,
];
Constants.IntMetaTypes = [
    0x21,
    0x59,
    0x51,
];
Constants.EndMetaTypes = [
    0x2F,
    -1, // EOF
];
Constants.MultiIntMetaTypes = {
    0x54: 5,
    0x58: 4, // Time signature
};
Constants.DualIntTypes = [
    0xA,
    0xB,
    0xE,
    0x8,
    0x9, // Note On
];
Constants.IntTypes = [
    0xC,
    0xD, // Aftertouch channel
];
